var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageHeaderClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 293.391,
    height: 110.757,
    viewBox: "0 0 293.391 110.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13825",
    "data-name": "Group 13825",
    transform: "translate(-1022.25 -71.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13808",
    "data-name": "Group 13808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13162",
    "data-name": "Group 13162",
    transform: "translate(1097.074 79.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-229.935,248.125h-1.742c.066-.985.147-1.965.147-2.97a44.121,44.121,0,0,0-44.119-44.119,44.1,44.1,0,0,0-41.129,28.239,21.658,21.658,0,0,0-15.272-6.28,21.738,21.738,0,0,0-21.735,21.74,21.685,21.685,0,0,0,.346,3.742,28.179,28.179,0,0,0-23.984,27.847,28.2,28.2,0,0,0,28.2,28.2h119.29a28.2,28.2,0,0,0,28.2-28.2A28.2,28.2,0,0,0-229.935,248.125Z",
    transform: "translate(377.422 -201.035)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13139",
    "data-name": "Group 13139",
    transform: "translate(1087.31 72.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M-229.935,248.125h-1.742c.066-.985.147-1.965.147-2.97a44.121,44.121,0,0,0-44.119-44.119,44.1,44.1,0,0,0-41.129,28.239,21.658,21.658,0,0,0-15.272-6.28,21.738,21.738,0,0,0-21.735,21.74,21.685,21.685,0,0,0,.346,3.742,28.179,28.179,0,0,0-23.984,27.847,28.2,28.2,0,0,0,28.2,28.2h119.29a28.2,28.2,0,0,0,28.2-28.2A28.2,28.2,0,0,0-229.935,248.125Z",
    transform: "translate(377.422 -201.035)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13140",
    "data-name": "Group 13140",
    transform: "translate(1266.297 80.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9-3",
    "data-name": "Path 9",
    d: "M-336.629,214.06h-.482c.018-.272.041-.543.041-.822a12.2,12.2,0,0,0-12.2-12.2,12.2,12.2,0,0,0-11.376,7.81,5.99,5.99,0,0,0-4.224-1.737,6.012,6.012,0,0,0-6.012,6.013,6,6,0,0,0,.1,1.035,7.794,7.794,0,0,0-6.634,7.7,7.8,7.8,0,0,0,7.8,7.8h32.994a7.8,7.8,0,0,0,7.8-7.8A7.8,7.8,0,0,0-336.629,214.06Z",
    transform: "translate(377.422 -201.035)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_31_2",
    "data-name": "Component 31 \\u2013 2",
    transform: "translate(1023 102.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9-4",
    "data-name": "Path 9",
    d: "M-336.629,214.06h-.482c.018-.272.041-.543.041-.822a12.2,12.2,0,0,0-12.2-12.2,12.2,12.2,0,0,0-11.376,7.81,5.99,5.99,0,0,0-4.224-1.737,6.012,6.012,0,0,0-6.012,6.013,6,6,0,0,0,.1,1.035,7.794,7.794,0,0,0-6.634,7.7,7.8,7.8,0,0,0,7.8,7.8h32.994a7.8,7.8,0,0,0,7.8-7.8A7.8,7.8,0,0,0-336.629,214.06Z",
    transform: "translate(377.422 -201.035)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageHeaderClouds);
export default __webpack_public_path__ + "static/media/page_header_clouds.0db3dc0f04580f45c565196f1c355a36.svg";
export { ForwardRef as ReactComponent };